/* eslint-disable @typescript-eslint/no-explicit-any */
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from '../api.service';
import { HomeService } from '../home.service';
import { isPlatformBrowser } from '@angular/common';
import { LocalStorageService } from './localstorage.service';

@Injectable({
  providedIn: 'root'
})
export class AbInfoPopupService {
  visibleInfoPopup=false;
  infoPosition = 'top';
  is_displaySaveIdeaInfoPopup = false;
  pagename!: string;
  step_type='user_type';
  step = 1;
  user_type!: string; 
  isAskBudgetSec=false;
  heading="What best define you?";
  usertypedata =[ {
    // title:'I own the home',subtitle:'Interested in home improvement products',key:'House Owner',icon:'assets/images/info-popup/own-home.png',bgColor:'#f7f7f7',color:'#f56518'},{title:'I am Professional',subtitle:'Offer home design and interior services',key:'Professional',icon:'assets/images/info-popup/professional.png',bgColor:'#f7f7f7',color:'#f56518'},];
    title:'I own the home',key:'House Owner',icon:'https://res.cloudinary.com/afterbricks/image/upload/v1738906239/4_ewnr78.png',bgColor:'rgb(220 217 217)',color:'#f56518'},{title:'I am Professional',key:'Professional',icon:'https://res.cloudinary.com/afterbricks/image/upload/v1738906239/2_ldswbf.png',bgColor:'rgb(220 217 217)',color:'#f56518'},];
  productSelectionfor =[{title:'Partial Interior work',subtitle:'Select products for specific interior tasks',key:'Partial Work',icon:'assets/images/info-popup/partial-work.png',bgColor:'#f3f3f3'},{title:'Entire house interior',subtitle:'Require all products for complete interior work',key:'Entire House',icon:'assets/images/info-popup/full-interior.png',bgColor:'#f3f3f3'}]
      profeaturelist=[ {
        title:'',subtitle:'',icon:'https://res.cloudinary.com/afterbricks/image/upload/v1733134288/Image_20241130_191936_129_ru8lpt.png'},]
        // title:'Create BoM',subtitle:"Create a mood board for your client's projects.",icon:'assets/images/info-popup/BoM-icon.png'},{title:'Compare offers',subtitle:'Compare seller discounts and availability status',icon:'assets/images/info-popup/compare-offers.png'},{title:'Loyalty points',subtitle:'Enable cashback for clients & accumulate loyalty points',icon:'assets/images/info-popup/loyalty-point.png'},]
  footermsg='Search, Specify & Source Materials for Interiors'
  footermsgtwo='Afterbricks, A Phygital Tradeshow'
  selectedproductSelectionfor: any;
  hometypes!: any[];
  isHomeTypes!: boolean;
  selectedHomeId: any;
  is_project_error!: boolean;
  spaces_not_seleted!: boolean;
  is_info_popup_show=false;
  constructor(@Inject(PLATFORM_ID) private platformId: any, public _router: Router, private _actRouter: ActivatedRoute,public _as:AppService,public _hs: HomeService,private localStorageService: LocalStorageService) {
    // private ssrCookieService:SsrCookieService,
  }
  getdata() {
    // if (isPlatformBrowser(this.platformId)) {
    let displaypopup = false;
    if (this._router.url.split('/')[1].split('?')[0] == 'department') {
      this.pagename = 'Category page';
      displaypopup = true
    } else if (this._router.url.split('/')[1].split('?')[0] == 'd') {
      this.pagename = 'Category type page';
      displaypopup = true
    } else if (this._router.url.split('/')[1] == '') {
      this.pagename = 'Home page';
      displaypopup = true
    }
    
      if (displaypopup) { 
        setTimeout(() => {
          if(!this.localStorageService.getItem('isinfopopupviewed')){
            if(this._router.url.split("/")[1]==''){
              this.is_info_popup_show = true;
            }else{
              this.is_info_popup_show = false;
            }
            this.visibleInfoPopup = true;
          }
         
        },15000)
      }
  // }
    
  }
  onProduct() {
    this._hs.isdisplybrandpopup = true;
    this.visibleInfoPopup = false;
  }
  onSelectUserType(key:any){
    if(key=='Professional'){
      // this.heading = "Smart Search for Materials & Products";
      // this.step_type = 'pro-message';
      // this.footermsg = "Get qualified leads, e-business tags, and much more";
      // this.footermsg = "Get qualified leads, e-business tags, and much more";
    //   this.step = 2;
    // this.user_type = key;
    this.visibleInfoPopup = false;
    }else{
      this.step_type = 'product-selection-for';
      this.heading = "We have products both for";
      // this._hs.isdisplybrandpopup = true;
      this.visibleInfoPopup = false;
    }
    
    if(!this._as.isUserLoggedIn){
      this.CreateGuestUser(JSON.parse(this.localStorageService.getItem('uuid') || ''));
    }else{
      console.log("info popup")
      this.onSaveUserActivity();
    }
    
  }
  onProductSelectionFor(key:any){
  this.selectedproductSelectionfor = key ;
  if(key=='Entire House'){
    this.isAskBudgetSec=true;
  }else{
   this._hs.isdisplybrandpopup = true;
   this.visibleInfoPopup = false;
  }
 
   this.onSaveUserActivity();
  }
  oncontinue(){
    this.heading = "Are you searching products for";
  }
  onGoBudgetSec(){
    this._router.navigate([''],{queryParams:{isDisplayBudget:true}});
    this._as.isDisplayBudget = true;
    this._hs.activeBudgetSec='slHType';
    this.visibleInfoPopup = false;
    const infopopup ={
      budget:'Yes'
    }
    this.localStorageService.setItem('isinfopopupviewed', JSON.stringify(true));
    this.onSaveUserActivity();
    this.localStorageService.setItem('infopopup', JSON.stringify(infopopup));
  }

  closeInfoPopUp(){
    this.visibleInfoPopup=false;
    this._hs.isdisplybrandpopup = true;
   
    this.onSaveUserActivity();
  }


  reSetData(){
    this.heading ="Which describes you best";
    this.step = 1;
    this.isAskBudgetSec=false;
    this.step_type = "user_type";
  }
  onContinue(){
    this.visibleInfoPopup = false;
   this._hs.isdisplybrandpopup = true;
   this.localStorageService.setItem('isinfopopupviewed', JSON.stringify(true));
 
  }
  onSkip(){
    this.visibleInfoPopup = false;
  }
  onBack(){
    if(this.step == 3){
      this.step_type = 'product-selection-for';
      this.heading = "Are you searching products for";
    }else if(this.step == 2){
        this.reSetData()
    }
  }
  //============= GET SAVE IDEA INFO POPUP ===================//
 displaySaveIdeaInfoPopup(){
  
  if(!this.visibleInfoPopup && !this.localStorageService.getItem('isinfopopupSaveIdea')){
    
    if (isPlatformBrowser(this.platformId)) {
      // if (displaypopup) {
        setTimeout(() => {
          if(!this.localStorageService.getItem('isinfopopupSaveIdea')){
            this.is_displaySaveIdeaInfoPopup =true;
          }
         
        }, 0)
      }
   
  }
 }
 onNext(){
    this.getHomeType();
 }
 getHomeType() {
  const url = this._as.api_base_url + 'space/hometype/';
  this._as.getRequest(url, true)
    .subscribe((res:any) => {
      this.hometypes = [];
      for (const ht of res.data) {
        this.hometypes.push({ name: ht.name, id: ht.id, icon:ht.icon,autoplayTimeout: 1000 });
      }
      this.isHomeTypes = true;
    });
}

setHomeType(hometype?:any){
  if(hometype){
    this.is_project_error = false;
    this.selectedHomeId = hometype.id;
   
    this.onSaveUserActivity();
  }
}
onSaveIdiaBack(){
  this.isHomeTypes = false;
}
onHouseTypeSave(){
  if(!this.selectedHomeId){
    this.is_project_error = true
    return
  }
  const infopopupSaveIdea = {
    houseTypeId: this.selectedHomeId
  }
  this.localStorageService.setItem('isinfopopupSaveIdea', JSON.stringify(true));
  this.localStorageService.setItem('infopopupSaveIdea', JSON.stringify(infopopupSaveIdea));
  this.is_displaySaveIdeaInfoPopup =false;
  if(!this._as.isUserLoggedIn){
    this._as.isDisplayLogin=true;
  }
}

CreateGuestUser(myId:any) {
  const url = this._as.api_base_url + 'home/guest-userinfo/';
  this._as.postRequest(url, {guest_user:myId}, true).subscribe((res: any) => {
    if (res) {
      this.localStorageService.setItem('guestUserId', JSON.stringify(res.id));
      this.localStorageService.setItem('isinfopopupviewed', JSON.stringify(true));
      this.onSaveUserActivity();
    }
  })
}

onSaveUserActivity(){
  // const infopopupString = this.ssrCookieService.get('infopopup');
  // const infopopup = infopopupString ? JSON.parse(infopopupString) : {};
  // const mergedData = { ...infopopup, ...data };
  this.localStorageService.setItem('isinfopopupviewed', JSON.stringify(true));
  // let guestUserId:any;
  // try{
  //   guestUserId = JSON.parse(this.localStorageService.getItem('guestUserId')|| '');
  // }catch{
  //   guestUserId = null
  // }
  // if (guestUserId){
  //   const url = this._as.api_base_url + 'home/guest-userinfo/'+guestUserId+'/';
  // this._as.putRequest(url,data,false).subscribe(()=>{
   
 
  //   // if(this.ssrCookieService.get('cookieconsent_status')=='allow')
  //   //   this.ssrCookieService.set('infopopup',JSON.stringify(mergedData));
  // })
  // }
  
}
}
